// External Imports
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { styled, pxToRem, Stack, Text, Button } from '@lessonnine/design-system.lib';

// Internal Imports
import { getBabbelHomepageUrl } from '../../utils/url.js';
import { getEdition } from '../../selectors/getEdition.js';
import { getMatch } from '../../selectors/getMatch.js';
import { I18n } from '../I18n/I18n.jsx';
import { LANGUAGES } from '../../config/types/prop.js';
import { logger } from '../../utils/rollbar.js';
import { options } from '../../config/reactRedux.js';
import { breakpoints } from '../../config/css/breakpoints.mjs';

const FourOhFourNumber = styled.span`
  color: ${({ theme }) => theme.color.surface.foreground.tertiary};
  font-size: ${pxToRem(84)};
  font-weight: 600;

  @media ${breakpoints.desktop.min} {
    font-size: ${pxToRem(120)};
    margin-top: ${pxToRem(16)};
  }
`;

const Divider = styled.div`
  background-color: ${({ theme }) => theme.color.surface.container.separator};
  height: ${pxToRem(1)};
  margin: ${pxToRem(24)} 0;
  width: 80%;

  @media ${breakpoints.desktop.min} {
    width: 70%;
  }
`;

function NotFound({ currentEdition, pathMatch }) {
  const babbelHomepageUrl = getBabbelHomepageUrl(currentEdition);

  useEffect(() => {
    const { url, query } = pathMatch;
    const queryParameters =
      Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : '';
    const path = `${url}${queryParameters}`;
    logger.warning(`Page not found. Code 404, path='${path}'`);
  }, [pathMatch]);

  return (
    <Stack padding={[50, 0, 50, 0]}>
      <Stack alignItems="center" align="center">
        <FourOhFourNumber>404</FourOhFourNumber>
        <Divider />
      </Stack>
      <Stack alignItems="center" align="center" gap={32}>
        <Text fontWeight="700">
          <I18n field="no-page-found2" defaultText="Looks like this page doesn't exist..." />
        </Text>
        <Button href={babbelHomepageUrl} as="a">
          <I18n field="no-page-found3" defaultText="Go to Babbel Homepage" />
        </Button>
      </Stack>
    </Stack>
  );
}

NotFound.propTypes = {
  currentEdition: LANGUAGES.isRequired,
  pathMatch: PropTypes.shape({
    query: PropTypes.object, // eslint-disable-line react/forbid-prop-types -- object of key/value pairs
    url: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: getEdition(state),
  pathMatch: getMatch(state),
});

const withRedux = connect(mapStateToProps, undefined, undefined, options);
const NotFoundHoc = withRedux(NotFound);

// Module Exports
export { NotFoundHoc as NotFound };
